module.exports = __webpack_public_path__ + "img/verde.6637cc69.svg";